import { createContext, useEffect, useRef, useState } from "react";
import { decodeToken } from "react-jwt";
import { Outlet, useNavigate } from "react-router-dom";
import { apiSae, urlWebSockt } from "../services/api";
import { io } from "socket.io-client";
import { Bounce, toast } from "react-toastify";

export const HomeContext = createContext({});

export const HomeProvider = () => {
  const SaveDarkeMode = localStorage.getItem("SaeDarkMode");

  const [modalAvisosEmegencia, setModalAvisosEmegencia] = useState(false);
  const [infoUser, setInfoUser] = useState({});
  const [infoEstacao, setInfoEstacao] = useState([]);
  const [userOn, setUserOn] = useState({});
  const [socket, setSocket] = useState(null);
  const [loading, setLoading] = useState(false);
  const [darkMode, setDarkMode] = useState(
    SaveDarkeMode === "true" ? true : false
  );

  const [modalEditarSenha, setModalEditarSenha] = useState(false);

  const [modalBaixarApp, setModalBaixarApp] = useState(false);

  const reconnectAttempts = useRef(0);
  const MAX_RECONNECT_ATTEMPTS = 2;

  // const decodedToken = decodeToken(token);
  const navigate = useNavigate();
  const token = localStorage.getItem("tokenBrk");

  const headerApi = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const aoListarEstacoes = async (idCidade, reload) => {
    if (reload) {
      setLoading(true);
    }
    try {
      const listarEstacao = await apiSae.get(`estacao/leituratodos`, headerApi);

      const listaEstacaoTratada = listarEstacao.data.filter(
        (e) => e.cidade.id == idCidade
      );
      setInfoEstacao(listaEstacaoTratada);
    } catch (error) {
      console.log(error);
      if (error.response.status === 401) {
        let cofimationToken = localStorage.getItem("tokenBrk");
        if (!cofimationToken) {
          navigate("/Login");
          if (
            window.ReactNativeWebView &&
            window.ReactNativeWebView.postMessage
          ) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({ type: "route", path: "Exit" })
            );
          }
        }
        //  else {
        //   localStorage.removeItem("tokenBrk");
        //   navigate("/Login");
        //   toast.warn("Sessão expirada111111111", {
        //     position: "top-right",
        //     autoClose: 5000,
        //     theme: "dark",
        //     transition: Bounce,
        //   });
        // }
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!token) {
      sessionStorage.clear();
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    const newSocket = io(urlWebSockt, {
      path: "/67ZlfPVt/socket.io",
      auth: {
        token: token,
      },
      transports: ["websocket", "polling"],
      reconnectionAttempts: MAX_RECONNECT_ATTEMPTS,
      reconnectionDelay: 2000,
    });

    let usuarioSave;
    setSocket(newSocket);

    newSocket.on("connect", () => {
      reconnectAttempts.current = 0;
      console.log("WebSocket connected");
    });

    newSocket.on("user_data", (userData) => {
      setInfoUser(userData);
      setTimeout(() => (usuarioSave = userData), 1000);
    });

    newSocket.on("user_updated", (userData) => {});

    newSocket.on("update_elevatoria", (EleveatoriaData) => {
      aoListarEstacoes(1, false);
    });

    newSocket.on("changed_user", (userId) => {
      setUserOn(userId);
    });

    newSocket.on("User_desconectado_sessao", (userId) => {
      if (usuarioSave && usuarioSave.id === userId) {
        localStorage.removeItem("tokenBrk");
        navigate("/Login");
        if (
          window.ReactNativeWebView &&
          window.ReactNativeWebView.postMessage
        ) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({ type: "route", path: "Exit" })
          );
        }
        toast.warn("Novo Dispositivo Conectado!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          transition: Bounce,
        });
      }
    });

    newSocket.on("connect_error", (err) => {
      // Exibe uma mensagem mais amigável se a propriedade 'data' estiver disponível
      reconnectAttempts.current += 1;
      if (reconnectAttempts.current >= MAX_RECONNECT_ATTEMPTS) {
        localStorage.removeItem("tokenBrk");
        if (
          window.ReactNativeWebView &&
          window.ReactNativeWebView.postMessage
        ) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({ type: "route", path: "Exit" })
          );
        }
        navigate("/Login");
        const mensagem =
          err.data?.message === "Invalid token"
            ? "Sessão expirada"
            : "Falha ao conectar com o servidor";

        toast.warn(mensagem, {
          position: "top-right",
          autoClose: 5000,
          theme: "dark",
          transition: Bounce,
        });
      } else {
        console.warn("Tentativa de reconexão:", reconnectAttempts.current);
        if (err.message == "Invalid token") {
          localStorage.removeItem("tokenBrk");
          if (
            window.ReactNativeWebView &&
            window.ReactNativeWebView.postMessage
          ) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({ type: "route", path: "Exit" })
            );
          }
          navigate("/Login");
          const mensagem = "Sessão expirada";
          toast.warn(mensagem, {
            position: "top-right",
            autoClose: 5000,
            theme: "dark",
            transition: Bounce,
          });
        }
      }
    });

    return () => {
      newSocket.disconnect();
    };
  }, [token]);

  return (
    <HomeContext.Provider
      value={{
        navigate,
        infoUser,
        infoEstacao,
        setInfoEstacao,
        headerApi,
        aoListarEstacoes,
        socket,
        userOn,
        setUserOn,
        modalAvisosEmegencia,
        setModalAvisosEmegencia,
        modalBaixarApp,
        setModalBaixarApp,
        loading,
        modalEditarSenha,
        setModalEditarSenha,
        darkMode,
        setDarkMode,
      }}
    >
      <Outlet />
    </HomeContext.Provider>
  );
};
